import { Box } from '@mui/material';
import React from 'react';
import useWindowDimensions from '../../../Hooks/useWindowDimensions';

const BackgroundComponent: React.FC = () => {
	const windowDimensions = useWindowDimensions();
	const isMobile = windowDimensions.width < 768;

	const BackgroundStyle = {
		backgroundColor: 'transparent',
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
	};
	
	const ShapeStyle = {
		position: 'absolute',
		animationDuration: '1s',
		width: isMobile ? '60vw' : '40vw',
		height: isMobile? '60vw' : '40vw',
	};
	
	const circleStyle = {
		borderRadius: '50%',
	};
	
	const Shape1Style = {
		...ShapeStyle, 
		...circleStyle,
		background: 'linear-gradient(0deg, #ffffff00 0.02%, #E1F3EE 100.02%)',
		left: isMobile ? '-20%' : 0,
		top: isMobile ? '-15%' : '-70%',
		transform: 'rotate(-90deg)'
	};
	
	const Shape2Style = {
		...ShapeStyle, 
		background: 'linear-gradient(180deg, #ffffff00 5.66%, #E4FEF5 105.66%)',
		transform: 'rotate(-69.688deg)',
		left: isMobile ? '-25%' : '-20%',
		bottom: isMobile ? '-15%' : '-40%',
	};
	
	const Shape3Style = {
		...ShapeStyle, 
		...circleStyle,
		background: 'linear-gradient(180deg, #ffffff00 0%, #E1F3F2 100%)',
		right: isMobile ? '-20%' : '10%',
		bottom: isMobile ? '-15%' : '-70%',
		transform: 'rotate(-90deg)'
	};
	
	const Shape4Style = {
		...ShapeStyle, 
		transform: 'rotate(34.973deg)',
		background: 'linear-gradient(180deg, #ffffff00 2.99%, #EFFFFE 102.99%)',
		right: isMobile ? '-15%' : '-20%',
		top: isMobile ? '-15%' : '-30%',
	};

	return(
		<Box sx={BackgroundStyle}>
			<Box sx={{...Shape1Style, animationDelay: '0' }} className='animate__animated animate__fadeIn'></Box>
			<Box sx={{...Shape2Style, animationDelay: '0.3s' }} className='animate__animated animate__fadeIn'></Box>
			<Box sx={{...Shape3Style, animationDelay: '0.6s' }} className='animate__animated animate__fadeIn'></Box>
			<Box sx={{...Shape4Style, animationDelay: '0.9s' }} className='animate__animated animate__fadeIn'></Box>
		</Box>
	);
};

export default BackgroundComponent;